module.exports = __webpack_public_path__ + "static/media/blob1.2aecb024.svg";